// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2O9z3","productName":"Table_productName__3Vy78"};